import { auth as doAuthRequest } from "./bankid/auth";
import { collect as doCollectRequest } from "./bankid/collect";
import { cancel as doCancelRequest } from "./bankid/cancel";
import { refresh as doQrCodeRefreshRequest } from "./bankid/qrcode";
const validate = (response) => {
    if (!response || !response.successful || !response.response) {
        throw new Error("The request did not succeed");
    }
    return response.response;
};
export const auth = (requestOptions) => doAuthRequest(requestOptions).then(validate);
export const collect = (requestOptions) => doCollectRequest(requestOptions).then(validate);
export const cancel = (requestOptions) => doCancelRequest(requestOptions).then(() => true);
export const qrcode = (requestOptions) => doQrCodeRefreshRequest(requestOptions).then(validate);
